import { render, staticRenderFns } from "./product-variant-shell.vue?vue&type=template&id=2db15a11&"
import script from "./product-variant-shell.vue?vue&type=script&lang=js&"
export * from "./product-variant-shell.vue?vue&type=script&lang=js&"
import style0 from "./product-variant-shell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports